import React from 'react';
import { Link } from 'react-router-dom';

const ITConsulting = () => {
    const services = [
        {
            icon: '📊',
            title: 'IT Strategy & Planning',
            description: 'Develop comprehensive IT strategies aligned with your business objectives and growth plans.'
        },
        {
            icon: '🔍',
            title: 'Technology Assessment',
            description: 'Evaluate your current IT infrastructure and identify opportunities for optimization.'
        },
        {
            icon: '☁️',
            title: 'Cloud Solutions',
            description: 'Plan and execute cloud migrations to improve scalability, security, and cost efficiency.'
        },
        {
            icon: '🛡️',
            title: 'Cybersecurity',
            description: 'Protect your business with comprehensive security assessments and solutions.'
        },
        {
            icon: '🔄',
            title: 'Digital Transformation',
            description: 'Modernize your business processes with innovative digital solutions.'
        },
        {
            icon: '📈',
            title: 'IT Project Management',
            description: 'Expert management of complex IT projects from planning to successful delivery.'
        }
    ];

    const benefits = [
        {
            icon: '💰',
            title: 'Cost Optimization',
            description: 'Reduce IT costs while improving efficiency and performance.'
        },
        {
            icon: '🚀',
            title: 'Faster Innovation',
            description: 'Accelerate your digital initiatives with expert guidance.'
        },
        {
            icon: '🎯',
            title: 'Strategic Alignment',
            description: 'Ensure IT investments support your business goals.'
        },
        {
            icon: '⚡',
            title: 'Reduced Risk',
            description: 'Minimize technology risks with proven methodologies.'
        }
    ];

    return (
        <div className="page">
            {/* Hero Section — split layout */}
            <section className="page-hero-split">
                <div className="split-content">
                    <h1>IT <span className="text-gradient">Consulting</span></h1>
                    <p>
                        Strategic technology guidance to help your business leverage IT
                        for competitive advantage, growth, and operational excellence.
                    </p>
                </div>
                <div
                    className="split-image"
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/server-room-engineer.jpg)` }}
                />
            </section>

            {/* Services Section */}
            <section className="section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our <span className="text-gradient">Services</span></h2>
                        <p>Expert IT consulting services tailored to your business needs</p>
                    </div>
                    <div className="services-grid">
                        {services.map((service, index) => (
                            <div key={index} className="card card-gradient service-card">
                                <div className="service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="section bg-dark">
                <div className="container">
                    <div className="section-header">
                        <h2>Why Partner With <span className="text-gradient">Us</span></h2>
                        <p>The benefits of working with OnOneGroup for IT consulting</p>
                    </div>
                    <div className="features-grid">
                        {benefits.map((benefit, index) => (
                            <div key={index} className="feature-item">
                                <div className="feature-icon">{benefit.icon}</div>
                                <div className="feature-content">
                                    <h4>{benefit.title}</h4>
                                    <p>{benefit.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Infrastructure image divider */}
            <div
                className="image-divider"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/server-rack-glow.jpg)` }}
            >
                <div className="divider-content">
                    <h2>Built on <span className="text-gradient">Solid Infrastructure</span></h2>
                    <p>Modern, secure, and scalable systems designed for the enterprise.</p>
                </div>
            </div>

            {/* Approach Section */}
            <section className="section">
                <div className="container">
                    <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
                        <h2 className="mb-lg">Our <span className="text-gradient">Approach</span></h2>
                        <p className="text-muted mb-xl" style={{ fontSize: '1.125rem', lineHeight: '1.8' }}>
                            We believe in a collaborative, results-driven approach to IT consulting.
                            We work closely with your team to understand your unique challenges and
                            develop customized solutions that deliver measurable business value.
                        </p>
                        <div className="card card-gradient" style={{ padding: '2rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: '2rem' }}>
                                <div>
                                    <h3 className="text-gradient">1. Assess</h3>
                                    <p className="text-muted">Understand current state</p>
                                </div>
                                <div>
                                    <h3 className="text-gradient">2. Plan</h3>
                                    <p className="text-muted">Develop strategy</p>
                                </div>
                                <div>
                                    <h3 className="text-gradient">3. Execute</h3>
                                    <p className="text-muted">Implement solutions</p>
                                </div>
                                <div>
                                    <h3 className="text-gradient">4. Optimize</h3>
                                    <p className="text-muted">Continuous improvement</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="section">
                <div className="container">
                    <div className="cta-section">
                        <div className="cta-content">
                            <h2>Ready to Transform Your IT?</h2>
                            <p>
                                Schedule a consultation to discuss how we can help optimize your technology strategy.
                            </p>
                            <Link to="/contact" className="btn btn-primary">
                                Schedule Consultation →
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ITConsulting;
